export default __webpack_public_path__ + "static/media/7.9044b2c0.png";